export default {
    VERSION: '[[VERSION]]',
    SELF_HOSTED: false,
    VERSION_MOUNTAIN: 'Lütispitz',
    VERSION_MOUNTAIN_URL: 'https://de.wikipedia.org/wiki/L%C3%BCtispitz',
    VERSION_MOUNTAIN_IMAGE_URL: 'img/bg.original.jpg',
    VERSION_MOUNTAIN_IMAGE_COPYRIGHT: 'CC BY-SA 3.0 dbrgn',
    VERSION_MOUNTAIN_HEIGHT: 1987,
    GIT_BRANCH: 'master',
    PREV_PROTOCOL_LAST_VERSION: '1.8.2',
    IN_MEMORY_SESSION_PASSWORD: false,
};
